import { render, staticRenderFns } from "./trainingList.vue?vue&type=template&id=46c7a8d0&scoped=true&"
import script from "./trainingList.vue?vue&type=script&lang=js&"
export * from "./trainingList.vue?vue&type=script&lang=js&"
import style0 from "./trainingList.vue?vue&type=style&index=0&id=46c7a8d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7a8d0",
  null
  
)

export default component.exports